import { useState } from "react";
import styled from "styled-components";

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 100px;
  margin-top: 100px;
  position: auto;
`;

const GridContainer = styled.div`
  width: 1400px;
  height: 860px;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 1440px) {
    width: 90%;
    height: min-content;
    display: flex;
    flex-direction: column;
  }

  margin-bottom: 100px;
`;

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const InfoContainer = styled.div`
  height: 100vh;
  width: 80%;
  background-color: rgb(255, 254, 239);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // border: 1px solid #253569;
  border-radius: 4px;
  text-align: center;

  @media (max-width: 760px) {
    width: 90%;
  }
`;

const InfoInnerContainer = styled.div`
  font-family: Karla;
  width: 60%;
  flex-direction: row;
  @media (max-width: 1420px) {
    width: 80%;
  }

  @media (max-width: 760px) {
    width: 100%;
  }
`;

const Button = styled.a`
  border: 2px solid #253569;
  padding: 12px 22px;
  text-decoration: none;
  color: #253569;
  font-size: 1.2em;
  font-weight: 500;
  cursor: pointer;
`;

const Image = styled.img`
  border-radius: 4px;
  cursor: pointer;
  margin: auto;

  width: 680px;
  @media (max-width: 1080px) {
    width: 480px;
  }

  @media (max-width: 560px) {
    width: 400px;
  }

  @media (max-width: 460px) {
    width: 300px;
  }
`;

const Video = ({ id, imageSrc, selectVideo }) => {
  return (
    <VideoContainer>
      <Image
        onClick={() => {
          selectVideo(id);
        }}
        src={imageSrc}
      />
    </VideoContainer>
  );
};

const VideoGrid = ({ selectVideo }) => {
  return (
    <GridContainer>
      <Video selectVideo={selectVideo} imageSrc={"./hnp.png"} id={"HNP"} />
      <Video selectVideo={selectVideo} imageSrc={"./tpj.jpg"} id={"TPJ"} />
      <Video selectVideo={selectVideo} imageSrc={"./spana2.png"} id={"SPANA"} />
      <Video selectVideo={selectVideo} imageSrc={"./teenmums.png"} id={"TM"} />
    </GridContainer>
  );
};

const InfoData = {
  HNP: {
    content: [
      "Across the world over 70 communities gather annually to cycle nude through the streets. Happy Naked People explores their passionate stand for road safety, body positivity and climate change awareness as well as the challenges riding in the nude can present depending on your postcode.",
      "Happy Naked People was created in six days out of the challenge set by the Quarantine International Film Festival during the COVID-19 pandemic. At a time when we were all physically disconnected, we wanted to interview people online to bring together perspectives from around the globe to explore an event which was so at odds with our current situation. We ultimately made a film which celebrates community and the spirit of banding together under a common cause.",
    ],
    title: "Happy Naked People - Co-Director and Editor",
    imageSrc: "./hnp.png",
    btn: "VIEW FILM",
    href: "https://youtu.be/90uKP2bZNa8?si=FC5E_rNi1D4-idlP",
  },
  TPJ: {
    content: [
      "Carlos is 33 and living with schizophrenia. He's also a goalkeeper and the captain of a football team. Some days, he can't face getting out of bed. Some days he ends up in hospital. Yet every week he's there for tough, rigorous training with FC Pol Positiu.",
      "All to Play For follows the journey of the 18 players that form the team. Their coach, Max, is unrelenting, but he's getting results – the team has been undefeated for two years - and in Barcelona, a city so synonymous with football, even in a local league that's a record worth taking notice of.",
    ],
    title:
      "All to Play For (Todo por jugar) - Co-Director, Camera Operator, Editor and Researcher",
    imageSrc: "./tpj.jpg",
    btn: "VIEW TRAILER",
    href: "https://vimeo.com/ondemand/312907/514388285",
  },
  SPANA: {
    content: [
      "I edited case study videos for international animal welfare charity SPANA's social media channels. For each film, I logged footage, created a narrative arc, edited interviews, sourced music, and wrote captions and subtitles. These films were watched by thousands of people with one reaching 142.4K views on Facebook.",
    ],
    title:
      "The Society for the Protection of Animals Abroad (SPANA) - Freelance Video Editor",
    imageSrc: "./spana2.png",
    btn: "VIEW VIDEO",
    href: "https://www.facebook.com/watch/?v=2944006498976763",
  },
  TM: {
    content: [
      "Conversations with Teen Mums is a New Zealand web-based interactive documentary which combines films, photos, written interviews, and quotes. It gives an insight into the minds and lives of young millennial and Gen Z mums who were thrust into motherhood as teenagers.",
    ],
    title: "Conversations with Teen Mums - Editorial Assistant",
    imageSrc: "./teenmums.png",
    btn: "VIEW PROJECT",
    href: "http://www.conversationswithteenmums.co.nz/",
  },
};

const InfoSection = ({ cancelSelection, selectedKey }) => {
  return (
    <InfoContainer onClick={cancelSelection}>
      <InfoInnerContainer>
        <div>
          <Image
            style={{ borderRadius: "8px" }}
            src={InfoData[selectedKey].imageSrc}
          />
        </div>
        <div>
          <h3 style={{ color: "#253569" }}>
            <em>{InfoData[selectedKey].title}</em>
          </h3>
          <div style={{ marginBottom: "40px", color: "#253569" }}>
            {InfoData[selectedKey].content.map((p) => (
              <p>{p}</p>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              // backgroundColor: "red",
              justifyContent: "center",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <Button href={InfoData[selectedKey].href} target={"_blank"}>
              {InfoData[selectedKey].btn}
            </Button>
            <Button onClick={cancelSelection}>CLOSE</Button>
          </div>
        </div>
      </InfoInnerContainer>
    </InfoContainer>
  );
};

const VideoComponent = () => {
  const [selected, setSelected] = useState(false);
  const [selectedKey, setSelectedKey] = useState("");

  const selectVideo = (id) => {
    setSelectedKey(id);
    setSelected(true);
  };

  const cancelSelection = () => {
    setSelected(false);
  };

  return (
    <OuterContainer>
      {selected ? (
        <InfoSection
          cancelSelection={cancelSelection}
          selectedKey={selectedKey}
        />
      ) : (
        <VideoGrid selectVideo={selectVideo} />
      )}
    </OuterContainer>
  );
};

export default VideoComponent;
